import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button } from "../Object";

const Problem = (props) => {
  return (
    <>
      <div className="p-box__wrap">
        <Media
          src="box-back/problem"
          alt="background"
          class="p-box__img--back"
        ></Media>
        <div className="p-box__wrap--white l-row">
          <div className="p-box__wrap--white__inner">
            <Title slug="problem"></Title>
            <Space size={["72px 0", "40px 0"]}>
              <ProblemList />
            </Space>
            <Texts slug="problem/body"></Texts>
          </div>
        </div>
      </div>
    </>
  );
};

const ProblemList = (props) => {
  const gridProps = {
    list: {
      dir: ["row"],
      gap: "22px",
      class: "",
      layout: ["100%"],
      class: "list",
    },
    item: {
      dir: ["column"],
      gap: "16px",
      class: "",
      layout: ["16px 1fr"],
      class: "item",
    },
  };

  const Item = (props) => {
    return (
      <>
        <li className="item">
          <Grid {...gridProps.item}>
            <Media src="common/icon-check" alt="check"></Media>
            <Texts slug={`problem-list/list${props.index}`}></Texts>
          </Grid>
        </li>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < 6; i++) {
    items.push(<Item key={i} index={i} />);
  }
  return (
    <>
      <ul className="list">
        <Grid {...gridProps.list}>{items}</Grid>
      </ul>
    </>
  );
};

export default Problem;
